"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifePageListRequest = void 0;
var LifePageListRequest = /** @class */ (function () {
    function LifePageListRequest() {
    }
    return LifePageListRequest;
}());
exports.LifePageListRequest = LifePageListRequest;
;
//# sourceMappingURL=lifePageList.request.js.map